import { useLocation } from 'react-router-dom'

export const getFlyOutPageNameFromUrl = () => {
  const { pathname } = useLocation()
  if (pathname.includes('products-listing')) {
    return 'Product listings'
  } else if (pathname.includes('overview')) {
    return 'Overview'
  } else if (pathname.includes('private-offers')) {
    return 'Private offers & Reseller authorizations'
  } else if (pathname.includes('revenue')) {
    return 'Revenue insights'
  } else if (pathname.includes('subscriptions')) {
    return 'Subscriptions'
  } else {
    return ''
  }
}
